import React, { useEffect, useRef } from 'react';
import { useAnalytics } from '../context/AnalyticsContext';
interface SectionTrackerProps {
  sectionName: string;
  children: React.ReactNode;
  className?: string;
}
export const SectionTracker: React.FC<SectionTrackerProps> = ({
  sectionName,
  children,
  className = ''
}) => {
  const {
    trackSectionView
  } = useAnalytics();
  const sectionRef = useRef<HTMLDivElement>(null);
  const hasTracked = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasTracked.current) {
        trackSectionView(sectionName);
        hasTracked.current = true;
      }
    }, {
      threshold: 0.5 // Track when 50% of section is visible
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [sectionName, trackSectionView]);
  return <div ref={sectionRef} className={className} data-id="element-1183">
      {children}
    </div>;
};